export default __webpack_public_path__ + "static/media/Helveticaneuecyr-light.d11c1906.woff2";